//@ts-nocheck
import React from "react";
import styles from "./DevFormGroupOptions.module.scss";
// import FixAltInstances from "./FixAltInstances/FixAltInstances";
// import RemoveFormInstanceFromAllTableFields from "./RemoveFormInstanceFromAllTableFields/RemoveFormInstanceFromAllTableFields";
// import ScopedCallbackExample from "./ScopedCallbackExample/ScopedCallbackExample";
// import FixTableOrdering from "./FixTableOrdering/FixTableOrdering";
// import CombinePhotologs from "./CombinePhotologs/CombinePhotologs";
import { Button } from "@factorearth/component-library";
import { useTheme } from "@factorearth/component-library";

function DevFormGroupOptions(props) {
	const { formGroups, project, setDevFormGroupOptionsOpen } = props;
	const color = useTheme();

	return (
		<div className={styles.container}>
			Hey all! Once again, please don't click shit in here unless you know what you're doing!
			<Button colorPalette={color.theme} onClick={() => setDevFormGroupOptionsOpen(false)}>
				Back
			</Button>
			{/* <RemoveFormInstanceFromAllTableFields formGroups={formGroups} /> */}
			{/* <CombinePhotologs
				formGroups={formGroups}
				project={project}
			/> */}
			{/* <FixTableOrdering formGroups={formGroups} /> */}
			{/* <ScopedCallbackExample /> */}
			{/* <FixAltInstances formGroups={formGroups} /> */}
		</div>
	);
}

export default DevFormGroupOptions;
